export default {
  'menu.account': 'Аккаунт',
  'menu.account.center': 'Профиль',
  'menu.dashboard': 'Панель управления',
  'menu.health': 'Здоровье',
  'menu.devices': 'Устройства',
  'menu.devices.list': 'Список устройств',
  'menu.addressBook': 'Адресные книги',
  'menu.addressBook.personal': 'Личные',
  'menu.addressBook.shared': 'Общие',
  'menu.deviceGroups': 'Группы устройств',
  'menu.deviceGroups.list': 'Группы устройств',
  'menu.users': 'Пользователи',
  'menu.audits': 'Журналы аудита',
  'menu.audits.conn': 'Подключения',
  'menu.audits.file': 'Передача файлов',
  'menu.audits.alarm': 'Тревоги',
  'menu.audits.console': 'Консоль',
  'menu.login': 'Вход',
  'menu.roles': 'Роли',
  'menu.strategies': 'Стратегии',
  'menu.groups': 'Группы',
  'menu.groups.user': 'Группы пользователей',
  'menu.groups.device': 'Группы устройств',
  'menu.settings': 'Настройки',
  'menu.settings.general': 'Общие настройки',
  'menu.settings.relay': 'Реле',
  'menu.settings.clientUpdate': 'Обновление клиентов',
  'menu.settings.smtp': 'Настройки SMTP',
  'menu.settings.oidcProviders': 'Провайдеры OIDC',
  'menu.settings.ldap': 'Настройки LDAP',
  'menu.customClients': 'Пользовательские клиенты',
  'menu.addressBooks': 'Адресные книги',
  'menu.list.audit-list': 'Список аудита',
  'menu.list.audit-list.File': 'Передача файлов',
  'menu.list.audit-list.Connection': 'Подключение',
  'menu.list.audit-list.Alarm': 'Тревога',
};
